// Mobile = below Tailwind's `md` breakpoint (767px and narrower). This is the
// same cutoff the bottom nav, sidebar and the `max-md:` utilities use, so JS
// and CSS always agree on what "mobile" means.
import { useMediaQuery } from "./useMediaQuery";

export const MOBILE_QUERY = "(max-width: 767px)";
export const STANDALONE_QUERY = "(display-mode: standalone)";

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

/** True when running as an installed PWA (home-screen icon) rather than in a browser tab. */
export function useIsStandalone(): boolean {
  return useMediaQuery(STANDALONE_QUERY);
}
